function UserPoint(idOrObj, cid, lat, lon, name) {
    if (typeof idOrObj == 'object' && idOrObj != null) {
        this.id = idOrObj.id
        this.cid = idOrObj.cid
        this.lat = Number(idOrObj.lat)
        this.lon = Number(idOrObj.lon)
        this.name = idOrObj.name        
    }
    else {
        this.id = idOrObj
        this.cid = cid
        this.lat = Number(lat)
        this.lon = Number(lon)
        this.name = name        
    }
}

UserPoint.prototype.isSaved = function() {
    return (this.id || '') != ''
}

export default UserPoint